import { lazy } from "react";
import { withBotBGrid } from "../../hoc/withBotBGrid";
import Rte from "../widgets/rte";
import HomepageCompetitions from "./homepageCompetitions/homepageCompetitions";
import PrizeStatsBanner from "./prizeStatsBanner";
import LazyOnVisible from "@/app/shared-components/LazyOnVisible";

// Lazy: the winners slider (gsap + ScrollTrigger, ~365 KiB of source) sits far below the fold,
// so its chunk is only fetched when the user scrolls near it. Same pattern as WinnersFeedWidget.
const DreamCarWinners = lazy(() => import("./dreamCarWinners"));

const HomepageMacro = ({ controls }: { controls: any }) => {
  const renderMacro = (control: any) => {
    if (control !== null && control.editor !== null && control.editor.view !== null) {
      const view = control.editor.render ?? control.editor.view;
      if (view === "macro") {
        switch (control.value.macroAlias) {
          case "CompetitionCTAs":
            return (
              <div className="w-full flex flex-col gap-10 mb-10">
                <HomepageCompetitions />
              </div>
            );
          case "WinnerSlider":
            return (
              <LazyOnVisible rootMargin="800px">
                <DreamCarWinners />
              </LazyOnVisible>
            );
          case "PrizeStatsBanner":
            return <PrizeStatsBanner />;
        }
      } else {
        return <Rte xmlString={control.value} />;
      }
    }
  };

  return controls?.map((control: any, controlIndex: number) => <div key={controlIndex}>{renderMacro(control)}</div>);
};

export const HomepageMacros = withBotBGrid(HomepageMacro);
